export default "__VITE_ASSET__5ebe0eaa__"